var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticStyle:{"height":"100%"}},[_vm._t("default",null,{"product":_vm.wizardProduct,"addProduct":_vm.addProduct,"campaign":_vm.campaign,"isLoading":_vm.isLoading})],2)}
var staticRenderFns = []

export { render, staticRenderFns }